<template>
	<b-row>
		<b-col cols="12">
			<b-card-group class="shadow-sm mb-4">
				<b-card class="text-center">
					<p class="h4 font-weight-bold mb-1">
						<span v-if="!favorableCasesPercent" class="text-muted">&mdash;</span>
						<span v-else>{{ favorableCasesPercent }}%</span>
					</p>
					<p class="small text-muted mb-0">Favorable Cases</p>
				</b-card>
				<b-card class="text-center">
					<p class="h4 font-weight-bold mb-1">
						<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
						<span v-else class="mx-0 px-0">
							{{ $filters.abbreviatedCurrency(openClaimsTotal) }}
						</span>
					</p>
					<p class="small text-muted mb-0">Open Claims</p>
				</b-card>
				<b-card class="text-center">
					<p class="h4 font-weight-bold mb-1">
						<span v-if="!reimbursedTotal" class="text-muted">&mdash;</span>
						<span v-else class="mx-0 px-0">
							{{ $filters.abbreviatedCurrency(reimbursedTotal) }}
						</span>
					</p>
					<p class="small text-muted mb-0">Reimbursed</p>
				</b-card>
			</b-card-group>
		</b-col>
		<b-col cols="12" lg="6">
			<b-card class="mb-4 shadow-sm" no-body header="Cases" header-class="font-weight-bold">
				<b-container fluid class="py-4">
					<b-row>
						<b-col cols="12" lg="12">
							<CasesBarChart @casesDataLoaded="handleCasesData" hide-title height="300px" />
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="1" lg="3" class="py-0" style="background-color: whitesmoke;border: 1px white;padding-left:0px;padding-right:0px;margin-top:15px;margin-left:32px;">
							<template>
								<b-card class="text-center" text-variant="black" style="height:104px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);">
									<h3>{{ totalOpen }}</h3>
									<template #footer>
										<small class="text-muted">Open Cases</small>
									</template>
								</b-card>
							</template>
						</b-col>
						<b-col cols="1" lg="3" class="py-0" style="background-color: whitesmoke;border: 1px white;padding-left:0px;padding-right:0px;margin-top:15px;margin-left:32px;">
							<template>
								<b-card class="text-center" text-variant="black" style="height:104px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);">
									<h3>{{ totalUtc }}</h3>
									<template #footer>
										<small class="text-muted">UTC</small>
									</template>
								</b-card>
							</template>
						</b-col>
						<b-col cols="1" lg="3" class="py-0" style="background-color: whitesmoke;border: 1px white;padding-left:0px;padding-right:0px;margin-top:15px;margin-left:32px;">
							<template>
								<b-card class="text-center" text-variant="black" style="height:104px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);">
									<h3>{{ totalClosed }}</h3>
									<template #footer>
										<small class="text-muted">Closed</small>
									</template>
								</b-card>
							</template>
						</b-col>
					</b-row>
					<b-collapse id="collapse-1" class="mt-2">
						<b-card>
							<b-list-group flush v-if="closedCasesByOutcome.length > 0">
								<b-list-group-item
									v-for="item in closedCasesByOutcome"
									:key="item.name"
									class="d-flex justify-content-between align-items-center"
								>
									<span> {{ item.name }}</span>
									<span v-if="item.count > 0" class="font-weight-bold">
										{{ item.count }}
									</span>
									<span v-else class="text-muted small">&mdash;</span>
								</b-list-group-item>
							</b-list-group>
						</b-card>
					</b-collapse>
				</b-container>
				<div class="d-flex justify-content-center align-items-center" style="background-color: #ebebeb;">
					<span v-b-toggle.collapse-1 style="font-size: larger;">
						<font-awesome-icon icon="chevron-down" fixed-width />
					</span>
				</div>
			</b-card>
		</b-col>
		<b-col cols="12" lg="6">
			<b-card class="mb-4 shadow-sm" no-body header="Appeals" header-class="font-weight-bold">
				<b-container fluid class="py-4">
					<b-row>
						<b-col cols="12">
							<AppealsLineChart @appealDataLoaded="handleAppealData" hide-title height="300px" :showFilter="{ value: true, defaultSelected: 'monthly' }" />
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="1" lg="2" class="py-0" style="background-color: whitesmoke;border: 1px white;padding-left:0px;padding-right:0px;margin-top:15px;margin-left:32px;">
							<template>
								<b-card class="text-center" text-variant="black" style="height:104px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);">
									<h3>{{ totalNewAppeal }}</h3>
									<template #footer>
										<small class="text-muted" style="font-size: 10px;">New</small>
									</template>
								</b-card>
							</template>
						</b-col>
						<b-col cols="1" lg="2" class="py-0" style="background-color: whitesmoke;border: 1px white;padding-left:0px;padding-right:0px;margin-top:15px;margin-left:7px;">
							<template>
								<b-card class="text-center" text-variant="black" style="height:104px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);">
									<h3>{{ totalOpenAppeal }}</h3>
									<template #footer>
										<small class="text-muted" style="font-size: 10px;">Open</small>
									</template>
								</b-card>
							</template>
						</b-col>
						<!-- <b-col cols="1" lg="2" class="py-0" style="background-color: whitesmoke;border: 1px white;padding-left:0px;padding-right:0px;margin-top:15px;margin-left:7px;">
							<template>
								<b-card class="text-center" text-variant="black" style="height:104px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);">
									<h3>{{ totalInProcessAppeal }}</h3>
									<template #footer>
										<small class="text-muted" style="font-size: 10px;">In Process</small>
									</template>
								</b-card>
							</template>
						</b-col> -->
						<b-col cols="1" lg="2" class="py-0" style="background-color: whitesmoke;border: 1px white;padding-left:0px;padding-right:0px;margin-top:15px;margin-left:7px;">
							<template>
								<b-card class="text-center" text-variant="black" style="height:104px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);">
									<h3>{{ totalSubmittedAppeal }}</h3>
									<template #footer>
										<small class="text-muted" style="font-size: 10px;">Submitted</small>
									</template>
								</b-card>
							</template>
						</b-col>
						<b-col cols="1" lg="2" class="py-0" style="background-color: whitesmoke;border: 1px white;padding-left:0px;padding-right:0px;margin-top:15px;margin-left:7px;">
							<template>
								<b-card class="text-center" text-variant="black" style="height:104px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);">
									<h3>{{ totalClosedAppeal }}</h3>
									<template #footer>
										<small class="text-muted" style="font-size: 10px;">Closed</small>
									</template>
								</b-card>
							</template>
						</b-col>
					</b-row>
					<b-collapse id="collapse-2" class="mt-2">
						<b-card>
							<b-list-group flush v-if="appealsByCaseType.length > 0">
								<b-list-group-item
									v-for="item in appealsByCaseType"
									:key="item.name"
									class="d-flex justify-content-between align-items-center"
								>
									<span> {{ item.name }}</span>
									<span v-if="item.count > 0" class="font-weight-bold">
										{{ item.count }}
									</span>
									<span v-else class="text-muted small">&mdash;</span>
								</b-list-group-item>
							</b-list-group>
						</b-card>
					</b-collapse>
				</b-container>
				<div class="d-flex justify-content-center align-items-center" style="background-color: #ebebeb;">
					<span v-b-toggle.collapse-2 style="font-size: larger;">
						<font-awesome-icon icon="chevron-down" fixed-width />
					</span>
				</div>
			</b-card>
		</b-col>
		<b-col cols="12" lg="6">
			<b-card class="mb-4 shadow-sm" no-body header="Amounts" header-class="font-weight-bold">
				<b-container fluid class="py-4">
					<b-row>
						<b-col cols="12">
							<AmountsLineChart hide-title height="300px" />
						</b-col>
					</b-row>
				</b-container>
			</b-card>
		</b-col>
	</b-row>
</template>

<script>
import { mapGetters } from "vuex";
import AppealsLineChart from "@/clients/components/charts/AppealsLine.vue";
import CasesBarChart from "@/clients/components/charts/CasesBar.vue";
import AmountsLineChart from "@/clients/components/charts/AmountsLine.vue";
export default {
	name: "ViewReportIndexHome",
	components: {
		AppealsLineChart,
		CasesBarChart,
		AmountsLineChart
	},
	props: {
        // Add a prop to control the visibility of the select tag
        // showFilter: {
        //     type: Boolean,
        //     default: true // Default value is true, meaning the select tag will be visible by default
        // }
    },
	data:{
		icon1: 'chevron-down',
		totalOpen: 0,
		totalUtc: 0,
		totalClosed: 0,
		totalNewAppeal:0,
		totalOpenAppeal: 0,
		totalInProcessAppeal: 0,
		totalSubmittedAppeal: 0,
		totalClosedAppeal: 0,

	},
	computed: {
		...mapGetters({
			// Statistics
			unassignedAppeals: "statistics/unassignedAppeals",
			emptyCases: "statistics/emptyCases",
			appealsByCaseType: "statistics/appealsByCaseType",
			closedCasesByOutcome: "statistics/closedCasesByOutcome",
			favorableCasesPercent: "statistics/favorableCasesPercent",
			openClaimsTotal: "statistics/openClaimsTotal",
			reimbursedTotal: "statistics/reimbursedTotal",
		}),
	},
	methods: {
		handleCasesData(casesData) {
			// Do something with casesData, such as assigning it to a data property
		
			this.totalOpen = casesData.totalOpen;
			this.totalUtc = casesData.totalUtc;
			this.totalClosed = casesData.totalClosed;
		},
		handleAppealData(appealData) {
			this.totalNewAppeal = appealData.totalNew;
			this.totalOpenAppeal =appealData.totalOpen;
			this.totalInProcessAppeal =appealData.totalInProcess;
			this.totalSubmittedAppeal =appealData.totalSubmitted;
			this.totalClosedAppeal =appealData.totalClosed;
		},
		toggleIcon() {
			this.icon1 = (this.icon1 === 'chevron-down') ? 'chevron-up' : 'chevron-down';
		}
	}
};
</script>
